/* Stylesheet */

.dev_options {
  .row {
    .col {
      padding: 0px 12px 0px 12px;
    }
  }
}
